import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuillEditorService } from '../../services/quill/quill.service';

@Component({
    selector: 'topo-rich-text-edit',
    templateUrl: './rich-text-edit.component.html',
    styleUrls: ['./rich-text-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RichTextEditComponent implements OnInit, OnDestroy {
  @Output() richTextUpdated = new EventEmitter<string>();
  @Output() cancelRichText = new EventEmitter<void>();
  @Input() backgroundCanClose: boolean = true;
  @Input() set isActive(value: boolean) {
    this._isActive = value;
    this._isActive$.next(value);
  }
  get isActive(): boolean {
    return this._isActive;
  }
  _isActive = false;
  _isActive$: Subject<boolean> = new Subject<boolean>();

  destroy$ = new Subject<void>();
  @Input() title: string;
  @Input() set value(value: string) {
    if (!value) {
      value = '';
    }
    this._value = value;
    if (!!this.editor) {
      this.htmlValue = value;
    }
  }
  @Input() enableMentions: boolean;
  @Input() mentionSearch: (args: any, renderList: any) => void;
  _value: string;
  htmlValue: string;
  editor: any;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private editorService: QuillEditorService
  ) {}

  ngOnInit() {
    this._isActive$.pipe(takeUntil(this.destroy$)).subscribe(isActive => {
      this.changeDetector.markForCheck();
    });
  }

  get editorModules() {
    this.editorService.init();
    return {
      toolbar: {
        container: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'font': [] }],
          [{ 'align': [] }],
          ['blockquote'],
          ['link'],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ redo: 'redo' }, { undo: 'undo' }]
        ],
        handlers: {
          redo: () => {
            this.editor?.history.redo();
          },
          undo: () => {
            this.editor?.history.undo();
          }
        }
      },
      history: { delay: 2000, maxStack: 500, userOnly: true },
      mention: {
        minChars: 1,
        mentionDenotationChars: ['@'],
        source: (searchTerm, renderList) => {
          this.mentionSearch(searchTerm, renderList);
        }
      }
    };
  }

  editorCreated(editor: any) {
    this.editor = editor;
    this.htmlValue = this._value;
    this.editor.focus();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancelClick(): void {
    this.cancelRichText.emit();
  }

  saveClick(): void {
    this.richTextUpdated.emit(this.htmlValue);
  }
}
